import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Link from "next/link";
import { useRouter } from "next/router";
var tabs = [
    {
        name: "Swap",
        href: "/swap",
        paths: [
            "/swap"
        ],
        icon: "swap"
    },
    {
        name: "Limit",
        href: "/limit-orders",
        paths: [
            "/limit-orders"
        ],
        icon: "limit"
    },
    {
        name: "Liquidity",
        href: "/liquidity",
        paths: [
            "/liquidity",
            "/add",
            "/remove",
            "/find",
            "/create"
        ],
        icon: "pool"
    }, 
];
export default function TradeTabs() {
    var pathname = useRouter().pathname;
    return /*#__PURE__*/ _jsx("div", {
        className: "exchange-ui mx-auto w-full max-w-xl px-4 pb-2 pt-7 sm:pt-8",
        children: /*#__PURE__*/ _jsx("nav", {
            className: "exchange-tabs",
            "aria-label": "Trade",
            children: tabs.map(function(tab) {
                var active = tab.paths.some(function(path) {
                    return pathname === path || pathname.startsWith("".concat(path, "/"));
                }) || pathname === "/" && tab.icon === "swap";
                return /*#__PURE__*/ _jsx(Link, {
                    href: tab.href,
                    children: /*#__PURE__*/ _jsxs("a", {
                        href: tab.href,
                        "aria-current": active ? "page" : undefined,
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                width: "19",
                                height: "19",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "1.7",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                "aria-hidden": "true",
                                children: tab.icon === "swap" ? /*#__PURE__*/ _jsx("path", {
                                    d: "M4 7h15m-4-4 4 4-4 4M20 17H5m4-4-4 4 4 4"
                                }) : tab.icon === "limit" ? /*#__PURE__*/ _jsx(_Fragment, {
                                    children: /*#__PURE__*/ _jsx("path", {
                                        d: "M4 20V4m0 16h16M8 15l4-5 4 2 4-7"
                                    })
                                }) : /*#__PURE__*/ _jsx(_Fragment, {
                                    children: /*#__PURE__*/ _jsx("path", {
                                        d: "m12 3 9 5-9 5-9-5 9-5Zm-9 9 9 5 9-5M3 16l9 5 9-5"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: tab.name
                            })
                        ]
                    })
                }, tab.href);
            })
        })
    });
};
